import React from 'react';
import { injectIntl } from 'react-intl';
import { isNotEmpty, parseClasses, staticImagesCdn } from '../../lib/ep';

const CountryFlag = (props) => {
	const country_id = props?.country_id ?? false;
	if(country_id === false) return null;

	const height = props?.height ?? '30px';
	const tooltip = props?.tooltip ?? false;

	const autotranslate = props?.autotranslate ?? true;
	let label = null;
	if(isNotEmpty(props, 'children')) {
		if(autotranslate) {
			const _label = props.intl.formatMessage({ id:props.children });
			label = (typeof(_label) == 'string') ? _label.replace("***", "") : _label;
		} else {
			label = props.children;
		}
	}

	let classname = props?.classname ?? 'flag';
	classname = parseClasses(classname, props._class);

	return (
		<span class={classname} style={props.style}>
			{(label != undefined) && (
				<span>{label}: </span>
			)}

			<div class="flag_c gui_pos_rel" style={(height !== false) ? { height } : null}>
				<img src={`${staticImagesCdn()}img/country_flags/${country_id.toLowerCase()}.png`} height='100%' alt="" />

				{(tooltip !== false) && (
					tooltip
				)}
			</div>
		</span>
	);
};

export default injectIntl(CountryFlag);